import api from "@/api";

const namespaced = true

const state = {
  fuelSupplyUtilizationData: [],
  routes: []
}

const getters = {
  fuelSupplyUtilizationData: (state) => state.fuelSupplyUtilizationData,
  routes: (state) => state.routes
}

const mutations = {
  SET_FUEL_SUPPLY_UTILIZATION_DATA: (state, payload) => {
    state.fuelSupplyUtilizationData = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  }
}

const actions = {
  async fetchFuelSupplyUtilization({ commit }, payload) {
    try {
      const { data } = await api.getFuelSupplyUtilization(payload)

      if (data.error) {
        commit('SET_FUEL_SUPPLY_UTILIZATION_DATA', [])
        return
      }

      commit('SET_FUEL_SUPPLY_UTILIZATION_DATA', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getFuelSupplyUtilRoutes()
  
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }
  
      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async sendFuelSupplyEmail({ rootGetters }, payload) {
    const filterConfig = rootGetters['Table/defaultConfig']
    try {
      await api.postFuelSupplySendEmail({ ...payload, ...(filterConfig?.search && {search: filterConfig.search }) })
    } catch (err) {
      throw err
    }
  },
  async getDefaultEmailRecipients({}, param) {
    try {
      const { data } = await api.getDefaultEmailRecipients(param)
      return data
    } catch(err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }